/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var spine_options_pb = require('../../spine/options_pb.js');
var spine_validate_constraint_violation_pb = require('../../spine/validate/constraint_violation_pb.js');
goog.exportSymbol('proto.spine.validate.ValidationError', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.validate.ValidationError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.spine.validate.ValidationError.repeatedFields_, null);
};
goog.inherits(proto.spine.validate.ValidationError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.validate.ValidationError.displayName = 'proto.spine.validate.ValidationError';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.spine.validate.ValidationError.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.validate.ValidationError.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.validate.ValidationError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.validate.ValidationError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.validate.ValidationError.toObject = function(includeInstance, msg) {
  var f, obj = {
    constraintViolationList: jspb.Message.toObjectList(msg.getConstraintViolationList(),
    spine_validate_constraint_violation_pb.ConstraintViolation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.validate.ValidationError}
 */
proto.spine.validate.ValidationError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.validate.ValidationError;
  return proto.spine.validate.ValidationError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.validate.ValidationError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.validate.ValidationError}
 */
proto.spine.validate.ValidationError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_validate_constraint_violation_pb.ConstraintViolation;
      reader.readMessage(value,spine_validate_constraint_violation_pb.ConstraintViolation.deserializeBinaryFromReader);
      msg.addConstraintViolation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.validate.ValidationError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.validate.ValidationError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.validate.ValidationError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.validate.ValidationError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConstraintViolationList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      spine_validate_constraint_violation_pb.ConstraintViolation.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ConstraintViolation constraint_violation = 1;
 * @return {!Array<!proto.spine.validate.ConstraintViolation>}
 */
proto.spine.validate.ValidationError.prototype.getConstraintViolationList = function() {
  return /** @type{!Array<!proto.spine.validate.ConstraintViolation>} */ (
    jspb.Message.getRepeatedWrapperField(this, spine_validate_constraint_violation_pb.ConstraintViolation, 1));
};


/** @param {!Array<!proto.spine.validate.ConstraintViolation>} value */
proto.spine.validate.ValidationError.prototype.setConstraintViolationList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.spine.validate.ConstraintViolation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.spine.validate.ConstraintViolation}
 */
proto.spine.validate.ValidationError.prototype.addConstraintViolation = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.spine.validate.ConstraintViolation, opt_index);
};


proto.spine.validate.ValidationError.prototype.clearConstraintViolationList = function() {
  this.setConstraintViolationList([]);
};


goog.object.extend(exports, proto.spine.validate);

// The code for parsing the Protobuf messages of this file from the JSON data.

let known_type_parsers = require('../../known_type_parsers.js');

proto.spine.validate.ValidationError.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.validate.ValidationError.fromObject(jsObject);
};

proto.spine.validate.ValidationError.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.validate.ValidationError();
  
  if (obj.constraintViolation !== undefined && obj.constraintViolation !== null) {
    obj.constraintViolation.forEach(
      (listItem, index, array) => {
        if (listItem === null) {
          msg.addConstraintViolation(null);
        } else {
          let value = proto.spine.validate.ConstraintViolation.fromObject(listItem);
          msg.addConstraintViolation(value);
        }
      }
    );
  }
  return msg;
};
